const { mergeMap } = require('rxjs/operators')
const { ofType } = require('redux-observable')

const { coupon: couponApi } = require('@doctoroncallcom/api')
const {
  GET_COUPON_LIST,
  GET_COUPON,
  CREATE_COUPON,
  UPDATE_COUPON,
  DELETE_COUPON,
  POST_APPLY_COUPON,
} = require('./constants')

const {
  getCouponListSuccess,
  getCouponListError,
  getCouponSuccess,
  getCouponError,
  createCouponSuccess,
  createCouponError,
  updateCouponSuccess,
  updateCouponError,
  deleteCouponSuccess,
  deleteCouponError,
  postApplyCouponSuccess,
  postApplyCouponError,
} = require('./actions')


const getCouponList = (action$, state$, { api }) => action$.pipe(
  ofType(GET_COUPON_LIST),
  mergeMap(action => couponApi.getCouponListApi(api, {
    skip: action.payload.skip,
    take: action.payload.take,
    search: action.payload.search,
  })
    .then(response => getCouponListSuccess(response.data))
    .catch(error => getCouponListError(error))),
)

const getCoupon = (action$, state$, { api }) => action$.pipe(
  ofType(GET_COUPON),
  mergeMap(action => couponApi.getCouponApi(api, action.payload.id)
    .then(response => getCouponSuccess(response.data))
    .catch(error => getCouponError(error))),
)

const createCoupon = (action$, state$, { api }) => action$.pipe(
  ofType(CREATE_COUPON),
  mergeMap(action => couponApi.createCouponApi(api, action.payload.couponData)
    .then(response => createCouponSuccess(response.data))
    .catch(error => createCouponError(error))),
)

const updateCoupon = (action$, state$, { api }) => action$.pipe(
  ofType(UPDATE_COUPON),
  mergeMap(action => couponApi.updateCouponApi(api, action.payload.id, action.payload.couponData)
    .then(response => updateCouponSuccess(response.data))
    .catch(error => updateCouponError(error))),
)

const deleteCoupon = (action$, state$, { api }) => action$.pipe(
  ofType(DELETE_COUPON),
  mergeMap(action => couponApi.deleteCouponApi(api, action.payload.id)
    .then(response => deleteCouponSuccess(response.data))
    .catch(error => deleteCouponError(error))),
)

const postApplyCouponEpic = (action$, state$, { api }) => action$.pipe(
  ofType(POST_APPLY_COUPON),
  mergeMap(action => couponApi.postCouponApplyApi(api, action.payload.data)
    .then(response => postApplyCouponSuccess(response.data))
    .catch(error => postApplyCouponError(error))),
)

module.exports = {
  getCouponList,
  getCoupon,
  createCoupon,
  updateCoupon,
  deleteCoupon,
  postApplyCouponEpic,
}
